<template>
  <div style="width: 100%">
    <v-autocomplete
      class="tema-eixo-combo"
      id="temas-select"
      v-model="filter.uf"
      item-text="nome"
      :filled="filled"
      item-name="nome"
      :item-value="valor"
      :items="municipios"
      label="UF"
      placeholder="Selecione uma UF"
      v-on:change="$emit('onChange')"
      :disabled="disabled"
      clearable
      :rules="rules"
      hide-details
      :multiple="multiple"
    >
      <template slot="no-data"> Nenhuma UF retornado </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { ufAPI } from "@/apis";

export default {
  name: "ComboMunicipios",
  props: {
    rules: {
      type: Array,
      default: () => {
        [];
      },
    },
    tipoInscricao: {
      type: String,
      default: "S",
    },
    filled: {
      type: Boolean,
      default: true,
    },
    filter: {
      type: Object,
      default: () => {
        ({ municipioId: null });
      },
    },

    label: {
      type: String,
      default: "",
    },
    valor: {
      type: String,
      default: "nome",
    },
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },

  mounted() {
    this.load();
  },
  methods: {
    ...mapActions(["setLoading"]),

    load() {
      ufAPI
        .list(this.tipoInscricao)
        .then(({ data }) => {
          this.municipios = data.data;
        })
        .catch((resp) => {
          console.log("Erro uf: ", resp);
          this.$notification.error("Erro ao obter Municipios");
        });
    },
  },
  data() {
    return {
      municipios: [],
    };
  },
};
</script>

<style scoped>
/* .tema-eixo-combo {
  padding: 0 0 20px;
} */
</style>
